// src/components/content/RiskRegister.js
import { useEffect, useRef, useState } from 'react';
import Header from '../header';
import {
  Select,
  MenuItem,
  Box, Card,
  CardContent, TableContainer, Button
} from '@mui/material';
import Iconify from 'src/components/iconify';
import { getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { LoadingScreen } from 'src/components/loading-screen';
import { LoadingButton } from '@mui/lab';
import IncomeStatementTableSheet from './income-statement-sheet-table ';
import { enqueueSnackbar } from 'notistack';
import { CSVLink } from 'react-csv';

const IncomeStatement = ({type,onSave, rowId}) => {
  const csvLinkRef = useRef();
  const [loading, setLoading] = useState(false);
  const [projectList, setprojectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState('All');
  const [selectedTime, setSelectedTime] = useState("monthly");
  const [yearsList, setYearsList] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [ csvData, setCsvData ] = useState(null);

  const isFirstLoad = useRef(true);
  const [tableData, setTableData] = useState([]);
 
  useEffect(() => {
    getProjects();
    getYearsList()
    getIncomeStaetement(selectedProject);
  }, [selectedTime, selectedYear]);

  const getIncomeStaetement = async (projectId) => {
    setLoading(true);
    const endpoint = projectId && projectId !== 'All'
      ? `${endpoints.accounting.income_statement.get_list}?${selectedProject ? `project_id=${projectId}` : ''}${selectedTime ? `&timeframe=${selectedTime}` : ''}${selectedYear !== 'All' && selectedTime === 'monthly' ? `&period=${selectedYear}` : ''}`
      : `${endpoints.accounting.income_statement.get_list}?timeframe=${selectedTime}${selectedYear !== 'All' && selectedTime === 'monthly' ? `&period=${selectedYear}` : ''}`;
    const data = await getRequest(endpoint);
    console.log('🚀 ~ getBalacneSheet ~ data:', data);
    setLoading(false);
    if (data) {
      setTableData(data);
    }
  };
  const getProjects = async () => {
    const data = await getRequest(endpoints.accounting.expenses.get_project_list);
    console.log('🚀 ~ getProjets ~ data:', data);
    if (data) {
      setprojectList(data);

    }
  };
  const getYearsList = async () => {
    const endpoint = `${endpoints.accounting.income_statement.get_list}?timeframe=yearly`
    const data = await getRequest(endpoint);
    const years = data.map((year) => {
      return year.period
    })
    setYearsList(years)
    if (isFirstLoad.current) {
      setSelectedYear(years.slice(-1)[0]);
      isFirstLoad.current = false;
    }
  }
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };
  const handleChange = (event) => {
    const projectId = event.target.value
    setSelectedProject(projectId);
    getIncomeStaetement(projectId)
    console.log('Selected Project ID:', event.target.value);
  };
  const handleTimeChange = (event) => {
    setSelectedTime(event.target.value);
  };
  const handleSubmitFilters = async ()=>{
      const formData = new FormData();
      formData.append('project_id', selectedProject === 'All' ? '' : selectedProject);
      formData.append('timeframe', selectedTime)
      selectedTime === 'monthly' && formData.append('period', selectedYear)
      formData.append('start_year', '')
      formData.append('end_year', '')
      formData.append('tab_name', 'income_statement')
      const formDataObject = {}
      formData.forEach((value, key) => {
        formDataObject[key] = value
      })

      setLoading(true);
      const response = await postRequest(`${endpoints.accounting.finance_statement.post_list}/${rowId}/finance-statement-shows`, formData);
      setLoading(false);
      if(response?.metadata?.success){
        enqueueSnackbar(JSON.stringify(response?.metadata?.message), {variant: 'success'})
        onSave()
      }else{
        enqueueSnackbar(JSON.stringify(response.message), {variant: 'error'})
      }
    }
    const handleExport = () => {
      if (csvLinkRef.current) {
        const csvFormattedData = [];
        
        // Add Title Row
        csvFormattedData.push(["Income Statement Report"]);
    
        // Create Headers
        const headers = ["Period", "Account", "Total Amount"];
        csvFormattedData.push(headers);
    
        // Function to process sections like revenue, expenses, etc.
        const processSection = (entityType, label) => {
          csvFormattedData.push([label]); // Section Header
    
          tableData?.forEach((periodData) => {
            if (periodData.details[entityType]?.length) {
              periodData.details[entityType].forEach((entity) => {
                csvFormattedData?.push([
                  periodData.period,
                  entity.account_name || "-",
                  entity.total_amount ? `$${parseFloat(entity.total_amount).toLocaleString()}` : "0",
                ]);
              });
              csvFormattedData.push([
                `Total ${label} (${periodData.period})`,
                "",
                `$${(periodData[`total_${entityType}`] || 0).toLocaleString()}`,
              ]);
    
              csvFormattedData.push([]); 
            }
          });
        };
        processSection("revenue", "Revenue");
        processSection("expenses", "Expenses");
        processSection("others", "Other Income");
        setCsvData(csvFormattedData);
        setTimeout(() => {
          csvLinkRef.current.link.click();
        }, 100);
      }
    };
    

  return (
    <>
      <Card sx={{ height: '100%', marginTop: '10px', overflow: 'hidden' }}>
        <CardContent>
          {loading ? (
            <Box height={700}>
              <LoadingScreen />
            </Box>
          ) : (
            <>
              <Header name="Income Statement    " />
              <Box
                sx={{
                  display: 'flex',
                  paddingBottom: '20px',
                  marginTop: "20px",
                  justifyContent: 'space-between',
                  gap: '12px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    padding: '5px 0',
                  }}
                >
                  <h5
                    style={{
                      fontSize: '14px',
                      fontWeight: '400',
                      color: '#333',
                      margin: '0',
                      textTransform: 'none',
                    }}
                  >
                    Project Name
                  </h5>
                  <Select
                    sx={{ minWidth: 65, height: 35 }}
                    value={selectedProject}
                    onChange={handleChange}
                  >
                    <MenuItem value="All">All</MenuItem>
                    {projectList?.map((project) => (
                      <MenuItem key={project.id} value={project.id}>
                        {project.name}
                      </MenuItem>
                    ))}
                  </Select>

                  <Select
                    sx={{ minWidth: 65, height: 35 }}
                    value={selectedTime}
                    onChange={handleTimeChange}
                  >
                    <MenuItem value="monthly">Monthly</MenuItem>
                    <MenuItem value="quarterly">Quarterly</MenuItem>
                    <MenuItem value="yearly">Yearly</MenuItem>
                  </Select>

                  {selectedTime === 'monthly' && (
                    <Select
                      sx={{ minWidth: 65, height: 35 }}
                      value={selectedYear}
                      onChange={handleYearChange}
                    >
                      {yearsList?.map((year) => {
                        return <MenuItem key={year} value={year}>{year}</MenuItem>
                      })}
                    </Select>
                  )}

                </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              className="dark-button"
              variant="contained"
              startIcon={<Iconify icon="ic:baseline-email" />}
            //onClick={handleOpenShareModal} // Updated to open modal and generate PDF
            >
              Share By mail
            </Button>
            <Button
              onClick={handleExport}
              className="dark-button"
              variant="contained"
              startIcon={<Iconify icon="solar:export-bold" />}
            >
              Export
            </Button>
        
          </Box>
              </Box>

              <Card
                sx={{
                  boxShadow: '0px 0px 30px 0px #64748B1A',
                }}
              >
                <TableContainer sx={{ position: 'relative', overflow: 'auto' }}>
                  <IncomeStatementTableSheet data={tableData} />
                </TableContainer>
              </Card>
            </>
          )}
        </CardContent>
      </Card>
      {
        <CSVLink
          ref={ csvLinkRef }
          filename="Balance_Sheet_Report.csv"
          data={ csvData || [] } // Ensure it's always an array
          style={ { display: "none" } }
        />

      }



      <Box sx={{ display: 'flex', justifyContent: 'end', gap: 2, marginTop: 2 }}>
        {type ? (
          <LoadingButton
            onClick={handleSubmitFilters}
            type="submit" variant="contained" className='dark-button'
          >
            Save
          </LoadingButton>
        ) :
          null
        }
      </Box>
    </>
  );
};
export default IncomeStatement;